(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9603],{

/***/ 92774:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search",
      function () {
        return __webpack_require__(78493);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 84649:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ Layout; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./src/features/base-ui/Image.js
var Image = __webpack_require__(94477);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-element-f0de968e.browser.esm.js + 1 modules
var emotion_element_f0de968e_browser_esm = __webpack_require__(20442);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./src/features/base-ui/index.js + 31 modules
var base_ui = __webpack_require__(82843);
// EXTERNAL MODULE: ./node_modules/react-icons/gi/index.esm.js
var index_esm = __webpack_require__(2585);
// EXTERNAL MODULE: ./src/hooks/dataProvider/index.js + 1 modules
var dataProvider = __webpack_require__(46766);
// EXTERNAL MODULE: ./src/features/webpage/Head.js
var Head = __webpack_require__(56857);
// EXTERNAL MODULE: ./src/features/webpage/Nav.jsx
var Nav = __webpack_require__(32238);
// EXTERNAL MODULE: ./src/features/page-builder/SearchModal.js
var SearchModal = __webpack_require__(84015);
// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var ai_index_esm = __webpack_require__(8193);
// EXTERNAL MODULE: ./src/features/ads/ad_selection.js + 2 modules
var ad_selection = __webpack_require__(12547);
;// CONCATENATED MODULE: ./src/features/webpage/WebsiteHeader.js
/* eslint-disable react/jsx-no-target-blank */ 












function ThemeHeader() {
    var theme = (0,emotion_element_f0de968e_browser_esm.u)();
    var data = (0,dataProvider/* useDataProvider */.x5)().data;
    var ref = (0,react.useState)(false), mobileMenuVisible = ref[0], setMobileMenuVisible = ref[1];
    var headerColor = theme.colors.websiteHeader.color;
    (0,react.useEffect)(function() {
        if (!window) return;
        var lastScrollTop = 0, delta = 15;
        var onScroll = function onScroll() {
            var st = window.pageYOffset || document.documentElement.scrollTop;
            if (Math.abs(lastScrollTop - st) <= delta) return;
            if (st > lastScrollTop && lastScrollTop > 0) {
                // downscroll code
                document.querySelector("header").style.top = "-86px";
            } else {
                // upscroll code
                document.querySelector("header").style.top = "0px";
            }
            lastScrollTop = st;
        };
        window.addEventListener("scroll", onScroll);
        // Clean up the event listener to prevent memory leaks
        return function() {
            window.removeEventListener("scroll", onScroll);
        };
    }, []);
    var ref1;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Head/* default */.Z, (0,_object_spread/* default */.Z)({}, data === null || data === void 0 ? void 0 : data.head)),
            (data === null || data === void 0 ? void 0 : data.showHeader) !== false && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Nav/* default */.Z, {
                        items: data === null || data === void 0 ? void 0 : data.menuItems,
                        visible: mobileMenuVisible,
                        onClose: function() {
                            return setMobileMenuVisible(false);
                        },
                        type: "mobile"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("header", {
                        className: theme.components.websiteHeader.className,
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(theme.components.websiteHeader.style, "                            transition:0.3s ease;@media (max-width:1024px){height:86px;}"),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            id: "nav-wrapper",
                            className: "w-full",
                            style: {
                                gap: 5
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Link */.rU, {
                                    id: "logo",
                                    href: "/",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                        id: "logo-wrapper",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
                                            noStyle: true,
                                            layout: "fill",
                                            objectFit: "contain",
                                            alt: "logo",
                                            src: "/img/project/logo.png"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Nav/* default */.Z, {
                                    items: data === null || data === void 0 ? void 0 : data.menuItems
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ad_selection/* default */.ZP, {
                                    ads: (ref1 = data === null || data === void 0 ? void 0 : data.siteAds) !== null && ref1 !== void 0 ? ref1 : [],
                                    location: "site_header_menu",
                                    style: {
                                        maxHeight: 60,
                                        objectFit: "contain"
                                    },
                                    Wrapper: function(param) {
                                        var children = param.children;
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                            style: {
                                                display: "inline-flex",
                                                gap: 5,
                                                alignItems: "center",
                                                maxHeight: "100%",
                                                overflow: "hidden",
                                                flex: 1,
                                                justifyContent: "flex-end"
                                            },
                                            children: children
                                        });
                                    }
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                    className: "flex mr-auto",
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchModal/* default */.Z, {
                                            trigger: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                                                id: "quik-search-btn",
                                                type: "button",
                                                className: "site-button-link",
                                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("svg{font-size:24px;color:", theme.colors.primary, ";font-weight:100;margin:0 1rem;}"),
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ai_index_esm/* AiOutlineSearch */.RB5, {})
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                                            className: "flex-item lg:hidden",
                                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", headerColor, ";border-right:1px solid\n                                            ", theme.colors.lightGray, ";padding:0 1rem;"),
                                            onClick: function() {
                                                setMobileMenuVisible(true);
                                            },
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* GiHamburgerMenu */.vHB, {
                                                className: "text-3xl"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var WebsiteHeader = (ThemeHeader);

// EXTERNAL MODULE: ./src/features/webpage/WebsiteFooter.js + 1 modules
var WebsiteFooter = __webpack_require__(89248);
// EXTERNAL MODULE: ./config.json
var config = __webpack_require__(51181);
;// CONCATENATED MODULE: ./src/features/utility/SchemaMarkupLocalWebsite.jsx


function SchemaMarkupLocalWebsite() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
            __html: '{\n            "@context" : "https://schema.org",\n            "@type" : "WebSite",\n            "name" : "'.concat(config.core.website_name, '",\n            "url" : "').concat(config.core.rootUrl, '"\n}')
        }
    });
}

;// CONCATENATED MODULE: ./src/features/layouts/Layout.js







function Layout(param) {
    var children = param.children, pageProps = param.pageProps;
    var locale = (0,router.useRouter)().locale;
    (0,react.useEffect)(function() {
        if (pageProps.redirect) router_default().push(pageProps.redirect.destination);
    }, [
        pageProps === null || pageProps === void 0 ? void 0 : pageProps.redirect
    ]);
    if (pageProps.redirect) return null;
    var ref;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: function(theme) {
            var ref1, ref2, ref3;
            return {
                color: (ref1 = theme.colors) === null || ref1 === void 0 ? void 0 : ref1.text,
                fontFamily: (ref = (ref2 = theme === null || theme === void 0 ? void 0 : theme.font[locale]) === null || ref2 === void 0 ? void 0 : ref2.main) !== null && ref !== void 0 ? ref : (ref3 = theme === null || theme === void 0 ? void 0 : theme.font["default"]) === null || ref3 === void 0 ? void 0 : ref3.main,
                backgroundColor: theme.colors.mainBackground,
                direction: [
                    "ar",
                    "fa"
                ].indexOf(locale) !== -1 ? "rtl" : "ltr"
            };
        },
        className: [
            "ar",
            "fa"
        ].indexOf(locale) !== -1 ? "" : "ltr",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WebsiteHeader, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Fab */.Lg, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                children: children
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SchemaMarkupLocalWebsite, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WebsiteFooter/* default */.Z, {})
        ]
    });
}


/***/ }),

/***/ 78493:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ search; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 11 modules
var esm = __webpack_require__(74614);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-icons/bs/index.esm.js
var index_esm = __webpack_require__(63750);
// EXTERNAL MODULE: ./src/features/base-ui/index.js + 31 modules
var base_ui = __webpack_require__(82843);
// EXTERNAL MODULE: ./src/features/layouts/Layout.js + 2 modules
var Layout = __webpack_require__(84649);
// EXTERNAL MODULE: ./src/features/webpage/index.js + 10 modules
var webpage = __webpack_require__(21648);
// EXTERNAL MODULE: ./src/hooks/dataProvider/index.js + 1 modules
var dataProvider = __webpack_require__(46766);
// EXTERNAL MODULE: ./config.json
var config = __webpack_require__(51181);
// EXTERNAL MODULE: ./src/utils/index.js + 3 modules
var utils = __webpack_require__(12311);
// EXTERNAL MODULE: ./src/utils/news.js
var utils_news = __webpack_require__(98993);
;// CONCATENATED MODULE: ./src/features/utility/SchemaMarkupNewsList.jsx




function SchemaMarkupNewsList(param) {
    var _newsList = param.newsList, newsList = _newsList === void 0 ? [] : _newsList;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
        id: "newslistschema",
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
            __html: '{\n                "@context": "https://schema.org",\n                "@type": "CollectionPage",\n                "mainEntity": {\n                  "@type": "ItemList",\n                  "itemListElement": [\n                      '.concat(newsList.map(function(news, idx) {
                var ref, ref1, ref2, ref3, ref4;
                var mainImage = (news === null || news === void 0 ? void 0 : (ref = news.thumbnail) === null || ref === void 0 ? void 0 : (ref1 = ref.file) === null || ref1 === void 0 ? void 0 : ref1.hash) && "/api/filedb/".concat(news.thumbnail.file.hash, ".").concat((ref2 = news.thumbnail.file) === null || ref2 === void 0 ? void 0 : ref2.ext);
                var author = "";
                if (news.reporter) {
                    author = '"author": {\n                            "@type": "Person",\n                            "givenName": "'.concat(news.reporter.first_name, '",\n                            "familyName": "').concat(news.reporter.last_name, '",\n                            "url": "').concat(config.core.rootUrl).concat((0,utils/* generateUrl */.nu)(news.reporter, "user"), '"\n                        }');
                } else if (news.author) {
                    author = '"author": {\n                            "@type": "Person",\n                            "name": "'.concat(news.author, '"\n                        }');
                } else {
                    author = '"author": {\n                            "@type": "Organization",\n                            "name": "'.concat(config.core.organization, '"\n                        }');
                }
                var reference = news.reference ? '"sourceOrganization":{\n                        "@type":"Organization",\n                        "name":"'.concat(news.reference.title, '"\n                        },') : "";
                var ref5, ref6;
                return '{\n                            "@type": "ListItem",\n                            "position": '.concat(idx + 1, ',\n                            "url": "').concat(config.core.rootUrl).concat((0,utils/* generateUrl */.nu)(news, "news"), '",\n                            "item": {\n                              "@type": "NewsArticle",\n                              "headline": "').concat(news.title.replace(/"/g, '\\"'), '",\n                              "datePublished": "').concat((0,utils_news/* newsDisplayedPubDate */.iu)(news, "iso"), '",\n                              "dateModified": "').concat((0,utils_news/* newsDisplayedPubDate */.iu)(news, "iso"), '",\n                              ').concat(author, ",\n                              ").concat(reference, "\n                              ").concat(mainImage ? '"image": "'.concat(config.core.rootUrl, "/_next/image?url=").concat(encodeURIComponent(mainImage), '&w=1200&q=75",') : "", '\n                              "description": "').concat((ref6 = (ref5 = (ref3 = news.abst) === null || ref3 === void 0 ? void 0 : ref3.replace(/"/g, '\\"')) !== null && ref5 !== void 0 ? ref5 : (ref4 = news.uptitle) === null || ref4 === void 0 ? void 0 : ref4.replace(/"/g, '\\"')) !== null && ref6 !== void 0 ? ref6 : "", '"\n                            }\n                          }');
            }), "\n                  ]\n                }\n              }")
        }
    });
}

// EXTERNAL MODULE: ./src/utils/menu.js
var menu = __webpack_require__(95235);
;// CONCATENATED MODULE: ./src/pages/search.js












function Results(param) {
    var _news = param.news, news = _news === void 0 ? [] : _news, menuServices = param.menuServices, q = param.q, tag = param.tag, author = param.author, content = param.content, _mainContent = param.mainContent, mainContent = _mainContent === void 0 ? "" : _mainContent, service = param.service, latest = param.latest, _page = param.page, page = _page === void 0 ? 1 : _page, _lastPage = param.lastPage, lastPage = _lastPage === void 0 ? false : _lastPage, advenys = param.advenys, buildTime = param.buildTime;
    var t = (0,esm/* useTranslation */.$G)([
        "common",
        "news"
    ]).t;
    var setData = (0,dataProvider/* useDataProvider */.x5)().setData;
    (0,react.useEffect)(function() {
        var ref;
        setData({
            menuItems: (0,menu/* createServiceMenu */.V)(menuServices),
            siteAds: (ref = advenys === null || advenys === void 0 ? void 0 : advenys.filter(function(a) {
                return a.location.indexOf("site_") === 0;
            })) !== null && ref !== void 0 ? ref : [],
            buildTime: buildTime
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        menuServices
    ]);
    var title = "آخرین اخبار";
    if (author) title = "اخبار درج شده توسط ".concat(author);
    var ref, ref1;
    if (q || tag || content || service) title = "".concat((ref1 = (ref = q !== null && q !== void 0 ? q : tag) !== null && ref !== void 0 ? ref : content) !== null && ref1 !== void 0 ? ref1 : service);
    var ref2, ref3, ref4, ref5;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("main", {
        className: "px-4 lg:px-2 xl:px-0 md:container mx-auto",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)((head_default()), {
                children: [
                    tag && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "canonical",
                        href: "".concat(config.core.rootUrl, "/tag/").concat(tag)
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                        name: "description",
                        content: "میتوانید بروزترین ".concat(title, " را اینجا بخوانید")
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                        property: "og:description",
                        content: "میتوانید بروزترین ".concat(title, " را اینجا بخوانید")
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("section", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    className: "grid lg:grid-cols-3 xl:grid-cols-4 gap-10 py-10",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            className: "lg:col-span-2 xl:col-span-3 order-1 h-max",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* SectionTitle */.NZ, {
                                    className: "my-6",
                                    children: (ref5 = (ref4 = (ref3 = (ref2 = q !== null && q !== void 0 ? q : tag) !== null && ref2 !== void 0 ? ref2 : service) !== null && ref3 !== void 0 ? ref3 : author) !== null && ref4 !== void 0 ? ref4 : content) !== null && ref5 !== void 0 ? ref5 : "آخرین اخبار"
                                }),
                                mainContent && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    className: "dynamic-content",
                                    style: {
                                        boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
                                        backgroundColor: "#fff",
                                        padding: 10,
                                        marginBottom: 10,
                                        borderRadius: "0.25rem"
                                    },
                                    dangerouslySetInnerHTML: {
                                        __html: mainContent
                                    }
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                    className: "grid gap-4 h-full mb-6",
                                    children: [
                                        news.map(function(item, idx) {
                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(webpage/* NewsCard */.eu, {
                                                type: "horizental",
                                                shadow: "lg",
                                                titleLines: 1,
                                                titleHtmlEl: "h5",
                                                horizentalImageSize: "narrow",
                                                contentStyle: {
                                                    fontSize: "0.9rem"
                                                },
                                                news: item,
                                                showAbst: true
                                            }, idx);
                                        }),
                                        !(news === null || news === void 0 ? void 0 : news.length) && "موردی یافت نشد"
                                    ]
                                }),
                                !!news.length && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                    className: "inline-flex gap-2",
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(base_ui/* Button */.zx, {
                                            type: "linkButton",
                                            hoverColor: page <= 1 ? "transparent" : "darkGray",
                                            color: page <= 1 ? "lighterGray" : "white",
                                            disabled: page <= 1,
                                            className: "flex-nowrap inline-flex",
                                            href: "/search?".concat(q ? "q=".concat(q) : "").concat(tag ? "tag=".concat(tag) : "").concat(service ? "service=".concat(service) : "").concat(latest ? "latest" : "", "&p=").concat(page - 1),
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* BsArrowRightShort */.UE1, {
                                                    style: {
                                                        display: "inline"
                                                    }
                                                }),
                                                t("صفحه ی قبلی", {
                                                    ns: "common"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(base_ui/* Button */.zx, {
                                            type: "linkButton",
                                            hoverColor: lastPage ? "transparent" : "darkGray",
                                            color: lastPage ? "lighterGray" : "white",
                                            disabled: lastPage,
                                            className: "flex-nowrap inline-flex",
                                            href: "/search?".concat(q ? "q=".concat(q) : "").concat(tag ? "tag=".concat(tag) : "").concat(service ? "service=".concat(service) : "").concat(latest ? "latest" : "", "&p=").concat(page + 1),
                                            children: [
                                                t("صفحه ی بعد", {
                                                    ns: "common"
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* BsArrowLeftShort */.i1r, {
                                                    style: {
                                                        display: "inline"
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            className: "flex order-2 gap-4 flex-wrap justify-center"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SchemaMarkupNewsList, {
                newsList: news
            })
        ]
    });
}
Results.Layout = Layout/* Layout */.A;
var __N_SSP = true;
/* harmony default export */ var search = (Results);


/***/ }),

/***/ 95235:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ createServiceMenu; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12311);



function traverse(current, res) {
    var maxdepth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    var ref, ref1;
    var _forward_link;
    //process current node here
    res = {
        id: current.id,
        label: current.title,
        link: (_forward_link = current.forward_link) !== null && _forward_link !== void 0 ? _forward_link : (0,___WEBPACK_IMPORTED_MODULE_0__/* .generateUrl */ .nu)(current, "service")
    };
    if ((ref = current.thumbnail) === null || ref === void 0 ? void 0 : ref.hash) res.thumbnail = "/api/filedb/".concat(current.thumbnail.hash, ".").concat(current.thumbnail.ext);
    res.children = [] //.map(c => traverse(tree, c, ))
    ;
    if ((ref1 = current.children) === null || ref1 === void 0 ? void 0 : ref1.length) maxdepth += 1;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        //visit children of current
        for(var _iterator = current.children.sort(function(a, b) {
            return a.position.localeCompare(b.position);
        })[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var ck = _step.value;
            res.children.push(traverse(ck, void 0, maxdepth));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    res.maxDepth = maxdepth;
    return res;
}
function createServiceMenu(menuServices) {
    var ref, ref1;
    var a = menuServices.map(function(a) {
        var ref2, ref3, ref4;
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, a), {
            position: [
                (ref = (ref2 = a.parent) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.position) === null || ref3 === void 0 ? void 0 : ref3.padStart(3, "0")) !== null && ref !== void 0 ? ref : "",
                (ref1 = (ref4 = a.position) === null || ref4 === void 0 ? void 0 : ref4.padStart(3, "0")) !== null && ref1 !== void 0 ? ref1 : "999"
            ].join(".")
        });
    });
    return a.sort(function(a, b) {
        return a.position.localeCompare(b.position);
    }).map(function(s) {
        return traverse(s);
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2013,5445,260,4617,3662,9866,4980,2876,1228,483,9829,9902,2311,2843,1747,9774,2888,179], function() { return __webpack_exec__(92774); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);